import { useRef, useState } from 'react';

const BREITE = 600;
const HOEHE = 200;

/**
 * Unterschrift auf dem Gerät: mit Finger oder Stift zeichnen, als PNG (600 × 200, ~5–30 KB) gespeichert.
 * Eine gespeicherte Unterschrift wird als Bild gezeigt; «Neu unterschreiben» löscht sie.
 */
export function Unterschrift({ wert, onChange, label = 'Unterschrift' }) {
  const ref = useRef(null);
  const zeichnet = useRef(false);
  const [leer, setLeer] = useState(true);

  if (wert) {
    return (
      <div className="stack" style={{ gap: 8 }}>
        <img src={wert} alt={`${label} (gespeichert)`} style={{ width: '100%', maxWidth: 360, aspectRatio: '3 / 1', objectFit: 'contain', background: '#fff', border: '1.5px solid var(--border)', borderRadius: 14 }} />
        <button type="button" className="btn secondary" style={{ alignSelf: 'flex-start' }} onClick={() => { onChange(''); setLeer(true); }}>Neu unterschreiben</button>
      </div>
    );
  }

  const punkt = (e) => {
    const r = ref.current.getBoundingClientRect();
    return [((e.clientX - r.left) / r.width) * BREITE, ((e.clientY - r.top) / r.height) * HOEHE];
  };
  const start = (e) => {
    const ctx = ref.current.getContext('2d');
    if (!ctx) return;
    Object.assign(ctx, { lineWidth: 3, lineCap: 'round', lineJoin: 'round', strokeStyle: '#10201B' });
    zeichnet.current = true;
    ref.current.setPointerCapture?.(e.pointerId);
    const [x, y] = punkt(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(x + 0.1, y + 0.1);
    ctx.stroke();
    setLeer(false);
  };
  const ziehen = (e) => {
    if (!zeichnet.current) return;
    const ctx = ref.current.getContext('2d');
    if (!ctx) return;
    const [x, y] = punkt(e);
    ctx.lineTo(x, y);
    ctx.stroke();
  };
  const ende = () => { zeichnet.current = false; };
  const loeschen = () => { ref.current.getContext('2d')?.clearRect(0, 0, BREITE, HOEHE); setLeer(true); };
  const uebernehmen = () => onChange(ref.current.toDataURL('image/png'));

  return (
    <div className="stack" style={{ gap: 8 }}>
      <canvas ref={ref} width={BREITE} height={HOEHE} aria-label={`${label}: hier mit dem Finger unterschreiben`} role="img"
        onPointerDown={start} onPointerMove={ziehen} onPointerUp={ende} onPointerCancel={ende} onPointerLeave={ende}
        style={{ width: '100%', maxWidth: 480, aspectRatio: '3 / 1', touchAction: 'none', background: '#fff', border: '1.5px dashed var(--border)', borderRadius: 14 }} />
      <div className="row" style={{ gap: 8 }}>
        <button type="button" className="btn secondary" onClick={loeschen} disabled={leer}>Löschen</button>
        <button type="button" className="btn" onClick={uebernehmen} disabled={leer}>Unterschrift übernehmen</button>
      </div>
    </div>
  );
}
